module.exports = __webpack_public_path__ + "media/images/stock_groups/f06c-0b0927ea82eb8f11eba03c54dbfa5852.svg";